// extracted by mini-css-extract-plugin
export var common_children = "styles-module--common_children--3991b";
export var common_container = "styles-module--common_container--3e1e8";
export var common_desc = "styles-module--common_desc--5bbdd";
export var common_layout = "styles-module--common_layout--e36f7";
export var common_title_desc_container = "styles-module--common_title_desc_container--96258";
export var new_common_en_layout = "styles-module--new_common_en_layout--35860";
export var new_common_layout = "styles-module--new_common_layout--1cd5c";